import {Pipe, PipeTransform} from '@angular/core';
import {resolveVariableDisplayName, VariablePublicNamesMap} from '../utils/variable-display-name';

/**
 * Renders a dataset variable's public-facing label (#23).
 *
 * Replaces `{{ key | titlecase }}` on every variable-label surface. `titlecase`
 * lower-cases everything after the first letter of each word, which turned the
 * configured `NO2_umol_l` into `No2_umol_l`.
 *
 * Usage: `{{ variableKey | variableDisplayName: publicNames }}`
 *
 * Pure: it depends only on its two arguments, so Angular re-evaluates it when the key
 * or the map reference changes — which is what happens when a component receives a
 * freshly fetched `/api/variables-public-names` payload.
 */
@Pipe({name: 'variableDisplayName'})
export class VariableDisplayNamePipe implements PipeTransform {
  transform(technicalKey: string, publicNames: VariablePublicNamesMap | null | undefined): string {
    return resolveVariableDisplayName(technicalKey, publicNames);
  }
}
